import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import type { ReferralsApplicationAnswer } from '@recruitee/referrals-types';
import { getOptions } from '@recruitee/walkthrough-utils';

@Injectable({ providedIn: 'root' })
export class ApplicationAnswersHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadApplicationAnswers(candidateId: number): Observable<ReferralsApplicationAnswer[]> {
    return this.httpApi
      .get(
        `/referral/applications/candidate/${candidateId}`,
        null,
        getOptions({ hasOnboarding: true }),
      )
      .pipe(map(data => data.applications));
  }
}
